var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gray-bg"},[_c('div',{staticClass:"center clearfix"},[_c('div',{staticClass:"succeed"},[_c('img',{attrs:{"src":_vm.succeedImg,"alt":"资料提交成功"}}),_vm._v(" "),_c('h6',{staticClass:"succeed-title"},[_vm._v("资料提交成功！请耐心等待！我们将尽快为您审核！")]),_vm._v(" "),_c('p',{staticClass:"succeed-text"},[_vm._v("资料提交成功后，位讯旅游工作人员将尽快与电话您联系。")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38efbca6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cooperation/succeed.vue
// module id = null
// module chunks = 